import React from 'react';
import { Route, Switch } from 'react-router-dom';
import List from './List';
import Edit from './Edit';

export default class Leads extends React.Component {
  render = () => {
    const { match } = this.props;
    return (
      <div>
        <Switch>
          <Route exact path={match.url} component={List}/>
          <Route exact path={`${match.url}/:appNumber`} component={Edit}/>
        </Switch>
      </div>
    );
  };
}



// WEBPACK FOOTER //
// ./src/components/Leads/index.js